import React, { useCallback, useState } from 'react'
import { Button, Typography } from 'antd'
import { CloseOutlined } from '@ant-design/icons'

import IntlMessages from '../../util/IntlMessages'
import { trackOnboardingCallCtaClick } from './track-onboarding-call-cta'
import { useOnboardingCallCtaVariant } from './use-onboarding-call-cta-variant'
import { useOnboardingCallCtaBooked } from './use-onboarding-call-cta-booked'
import { OnboardingCallCalendlyEmbedModal } from './OnboardingCallCalendlyEmbedModal'
import './onboarding-call-cta.less'

const { Paragraph, Text } = Typography

interface OnboardingCallDashboardBannerProps {
  companyId: string
  userId: string
}

export const OnboardingCallDashboardBanner: React.FC<OnboardingCallDashboardBannerProps> = ({ companyId, userId }) => {
  const abVariant = useOnboardingCallCtaVariant()
  const booked = useOnboardingCallCtaBooked(userId, companyId)
  /** In-memory only: hidden until user leaves dashboard; shows again on next visit (route remount). */
  const [dismissed, setDismissed] = useState(false)
  const [calendlyOpen, setCalendlyOpen] = useState(false)

  const onDismiss = useCallback(() => {
    setDismissed(true)
  }, [])

  const onBook = useCallback(() => {
    trackOnboardingCallCtaClick({
      placement: 'dashboard_banner',
      abVariant,
      companyId,
      userId,
    })
    setCalendlyOpen(true)
  }, [abVariant, companyId, userId])

  const closeCalendly = useCallback(() => setCalendlyOpen(false), [])

  if (booked) {
    return null
  }

  if (dismissed) {
    return null
  }

  return (
    <div className="onboarding-call-cta-dashboard dashboard-width">
      <Button type="text" className="onboarding-call-cta-dashboard__close" onClick={onDismiss} aria-label="Dismiss">
        <CloseOutlined />
      </Button>
      <div className="onboarding-call-cta-dashboard__inner">
        <div className="onboarding-call-cta-dashboard__copy">
          <div className="onboarding-call-cta-dashboard__badge-row">
            <span className="onboarding-call-cta-badge">
              <IntlMessages id="onboarding.callCta.limitedOffer" />
            </span>
          </div>
          <Paragraph className="onboarding-call-cta-dashboard__title">
            <IntlMessages id="onboarding.callCta.title" />
          </Paragraph>
          <Text className="onboarding-call-cta-dashboard__desc">
            <IntlMessages id="onboarding.callCta.descriptionLong" />
          </Text>
        </div>
        <Button type="primary" className="onboarding-call-cta-dashboard__btn" onClick={onBook}>
          <IntlMessages id="onboarding.callCta.bookNow" />
        </Button>
      </div>
      <OnboardingCallCalendlyEmbedModal open={calendlyOpen} onClose={closeCalendly} placement="dashboard_banner" userId={userId} companyId={companyId} />
    </div>
  )
}
